import React from 'react';

import { NextPageWithLayout } from 'next';

import { AppDownloadSection } from '../../../components/AppDownloadSection/AppDownloadSection';
import { Container } from '../../../components/Container/Container';
import { MetaTags } from '../../../components/MetaTags/MetaTags';
import { MILLION_CATCHES } from '../../../constants/constants';
import { CircleImageAndText } from '../components/CircleImageAndText';

import phoneFour from './assets/phoneFour.png';
import phoneOne from './assets/phoneOne.png';
import phoneThree from './assets/phoneThree.png';
import phoneTwo from './assets/phoneTwo.png';
import { HeaderSection } from '../components/HeaderSection';
import {
  META_FISHING_SPOT_TITLE,
  META_FISHING_SPOT_DESCRIPTION,
  META_FISHING_SPOT_CANONICAL,
} from '../../../constants/metadata';

export const FishingSpotsPage: NextPageWithLayout = () => {
  const headerDescription = `Struggling to find the perfect fishing spot? Fishbrain will help you find new places to
          fish with our interactive map and data from over ${MILLION_CATCHES} million catches.
          You’ll be surprised what fishing spots you can discover near you. Now, you are able to
          browse the map and discover the closest spots, or even select a fishing hole based on the
          type of species you want to catch.`;

  return (
    <Container className="p-0 sm:p-0 md:p-0">
      <MetaTags
        title={META_FISHING_SPOT_TITLE}
        description={META_FISHING_SPOT_DESCRIPTION}
        link={META_FISHING_SPOT_CANONICAL}
      />

      <HeaderSection
        headingText="Find the best fishing spots near you"
        bodyText={headerDescription}
        bodyClassName="md:w-col-10"
      />

      <CircleImageAndText
        imgSrc={phoneOne}
        imgAlt="Instant overviews of each fishing water in the Fishbrain app"
        headingText="Instant overviews of each fishing water"
        bodyText="Find out everything you need about your local fishing spots with the press of a button."
      />

      <CircleImageAndText
        imgSrc={phoneTwo}
        imgRight
        imgAlt="Millions of verified catches in the Fishbrain app"
        headingText="Millions of verified catches"
        bodyText="Never miss out on new catches from your local fishing spots and favourite anglers."
      />

      <CircleImageAndText
        imgSrc={phoneThree}
        imgAlt="River gauges and river flow in the Fishbrain app"
        headingText="River gauges and river flow"
        bodyText="Understanding river flow, height and temperature is crucial to your success when fishing streams and rivers. As you get familiar with local rivers, this information will help you know exactly what to expect before you hit the water."
      />

      <CircleImageAndText
        imgSrc={phoneFour}
        imgRight
        imgAlt="Local points of interest in the Fishbrain app"
        headingText="Local points of interest"
        bodyText="Fishbrain not only provides you with tons of catch data, we also have information on local points of interest just for anglers. Looking for a place to launch your boat for a day out on the water? Simply browse our map to find boat ramps, marinas, bait shops, and more. You can even find local fishing license vendors."
      />

      <AppDownloadSection />
    </Container>
  );
};
